export default function getInitials(value: string[]): string {
  const firstInitial = value[0].charAt(0);
  const lastInitial = value.length > 1 && value[value.length - 1].charAt(0);

  return firstInitial && `${firstInitial}${lastInitial || ''}`;
}
